// extracted by mini-css-extract-plugin
export default {"root":"UserCreatePage_root__kUDT9"};